module.exports = __webpack_public_path__ + "static/img/home_tractocamion.3cc4349.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/home_tractocamion.png
// module id = 89
// module chunks = 0